// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__I1Gsi","productName":"Table_productName__CFJTb"};